import { signal } from '@preact/signals';
import { Environment, environment } from '@utils/environment';

export const areDevToolsUnlocked = signal<boolean>(false);

export const devTools = {
    translationKeys: signal<string>('off'),
    showDevTools: signal<boolean>(
        environment === Environment.Local || environment === Environment.Dev || environment === Environment.Stage || areDevToolsUnlocked.value,
    ),
};
